define("shared/errors/missing-translation", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  class MissingTranslationError extends Error {
    constructor(message) {
      super(message);
      this.name = 'MissingTranslationError';
    }
  }
  _exports.default = MissingTranslationError;
});